import { colors, spacing, fonts } from '../../tokens';
export default {
  fontFamily: '"Metropolis", "Metropolis-Regular", sans-serif',
  wrapper: {
    padding: spacing.s,
    borderColor: colors.grey[200],
    borderRadius: spacing.xs
  },
  ratingTitle: {
    fonts: fonts.xs,
    fontWeight: fonts.weight.semibold,
    color: colors.grey[500],
    marginTop: spacing.m,
    marginBottom: spacing.m
  },
  scoreStar: {
    height: spacing.m,
    width: spacing.m,
    activeFill: colors.brand.primary,
    inactiveStroke: colors.grey[400]
  },
  scoreNumber: {
    fonts: fonts.xs,
    color: colors.grey[500],
    marginTop: spacing.s,
    marginBottom: spacing.s
  },
  modal: {
    title: {
      fonts: fonts.l,
      color: colors.dark,
      marginBottom: spacing.m
    },
    subtitle: {
      marginBottom: spacing.l,
      color: colors.dark,
      fonts: fonts.base
    },
    feedbackWrapper: {
      marginBottom: spacing.m
    },
    sendButton: {
      marginBottom: spacing.l,
      height: spacing.xxl4
    },
    cancelButton: {
      color: colors.brand.primary
    }
  }
};